import { getGlobalMonitor } from '@zg-rentals/monitor-base';
import type { BrowserIdentityState } from './browserIdentity';

type IdentityTelemetry = {
  status: BrowserIdentityState['status'];
  durationMs: number;
};

let registered = false;
let pendingTelemetry: IdentityTelemetry | undefined;

function emitIdentityTelemetry({ status, durationMs }: IdentityTelemetry): void {
  const monitor = getGlobalMonitor();
  monitor?.count({ name: `identity client outcome ${status}` });
  monitor?.measurementWithGauges({ name: 'identity client duration ms', amount: durationMs });
}

export function recordIdentityTelemetry(telemetry: IdentityTelemetry): void {
  if (!registered) {
    pendingTelemetry = telemetry;
    return;
  }

  emitIdentityTelemetry(telemetry);
}

export function flushIdentityTelemetry(): void {
  registered = true;
  if (!pendingTelemetry) return;

  emitIdentityTelemetry(pendingTelemetry);
  pendingTelemetry = undefined;
}
